import {
    ICancelGroupPotentialContraventionDetail,
    IGetGroupPotentialContraventionsCancelled,
} from '@EcamModel/controllers/IGroupPotentialContraventionHttpController';
import {
    CameraPhotoVehicles,
    CancellationReasons,
    ContraventionStatus,
    GeoZoneCoordinates,
    GroupPotentialContraventions,
    OutCome,
    PCNDuplicate,
    PermitData,
    PotentialContraventionLookUp,
    PotentialContraventionWithInfo,
} from '@EcamModel/model';
import ICDetails from '@assets/jsx-icon/ICDetails';
import ICNote from '@assets/jsx-icon/ICNote';
import BaseCheckbox from '@components/BaseCheckbox';
import BreadCrumbs, { IBreadCrumbs } from '@components/breadcumbs/BreadCumbs';
import { DrawerContext, DrawerPage } from '@components/drawer/useDrawer';
import useStyledAutocomplete from '@components/styled-autocomplete/useStyledAutocomplete';
import { pushError, pushSuccess, pushWarning } from '@components/toast';
import {
    auditVerificationHTTPController,
    pcController,
    potentialGroupContraventionController,
} from '@controllers/index';
import styled from '@emotion/styled';
import { LoadingButton } from '@mui/lab';
import { PiCubeFocusThin } from 'react-icons/pi';

import {
    IAuditAndApprovePotentialContravention,
    IAuditAndSkipPotentialContravention,
} from '@EcamModel/controllers/IVerificationAuditHttpController';
import ApproveIcon from '@assets/ApproveIcon';
import CancelIcon from '@assets/CancelIcon';
import CameraIcon from '@assets/drawer-icon/CameraIcon';
import ArrowDownButtonEndIcon from '@assets/jsx-icon/ArrowDownButtonEndIcon';
import AuditorIcon from '@assets/jsx-icon/AuditorIcon';
import WarningIcon from '@assets/jsx-icon/WarningIcon';
import PopUpWarning from '@components/PopUpWarning';
import BaseEnhancedTabs, { TabConfig } from '@components/tabs/BaseEnhancedTabs';
import { appConfig } from '@configs/index';
import usePopUp, { UsePopUpReturnType } from '@hooks/usePopUp';
import useScrollToTop from '@hooks/useScrollToTop';
import {
    Accordion,
    Box,
    Button,
    Collapse,
    Dialog,
    Divider,
    Fade,
    FormControlLabel,
    IconButton,
    Stack,
    Tooltip,
    Typography,
} from '@mui/material';
import { RESOLUTIONS } from '@pages/cameras/details/components/tabsGeozonesDetail/ptz/components/PopupConfigViewCameraPTZ';
import { PreviewImageWithGeoZone } from '@pages/cameras/details/components/tabsGeozonesDetail/solar/components/HistoriesPhoto';
import { getGeoZone } from '@pages/cameras/hook/CameraDetailsProvider';
import { useImageDimensions } from '@pages/cameras/live-photos/components/PreviewImage';
import { CustomTabPanel } from '@pages/overview/tabs/useTabsData';
import color from '@theme/Colors';
import theme from '@theme/Theme';
import Konva from 'konva';
import * as _ from 'lodash';
import moment from 'moment';
import { useContext, useEffect, useMemo, useRef, useState } from 'react';
import { BiSearchAlt } from 'react-icons/bi';
import { useQueryClient } from 'react-query';
import { Link, useLocation, useNavigate, useParams } from 'react-router-dom';
import { formatUKDateTime } from 'src/helpers';
import { useBackdrop } from 'src/providers/BackdropProvider';
import { PCGroup, PCInfo } from '..';
import { notesMO, PotentialContraventionContext } from '../hooks/PotentialContraventionProvider';
import { CropArea } from '../hooks/useEditImage';
import { MAX_HEIGHT, MAX_WIDTH, useImagePreviewDimensions } from '../hooks/useImageDimensions';
import useModal from '../hooks/useModal';
import DetailInfoSection, { DetailInfoItem } from './DetailInfoSection';
import DuplicatePCDetail, { outComeStatusMapping } from './DuplicatePCDetail';
import EvidencePhotoGroup, { PhotoItem, TransformWrapperComponent } from './EvidencePhotoGroup';
import ListPCNDuplicatesAdditionalInformation from './ListPCNDuplicatesAdditionalInformation';
import ModalCancellationReasons, { FormCancelReasonValues } from './ModalCancellationReasons';
import ModalChangePlate from './ModalChangePlate';
import NoteOPs from './NoteOPs';
import NoteVerifier from './NoteVerifier';
import PCGeoZonesDetail from './PCGeoZonesDetail';
import PermitDuplicate from './PermitDuplicate';
import { convertToCropArea } from './PopUpPlateEditing';
import PopUpSplitAndComplete from './PopUpSplitAndComplete';
import PopupChangeEvidence from './PopupChangeEvidence';
import RecordedPCNEventLogScreen from './recordedPCNEventLog';
import PopUpOpenLivePhotos from './PopUpOpenLivePhotos';
import { contraventionReasonEV } from '@pages/cameras/details/components/AddGeoZones';

type PCDetailProps = {
    handleApprove?: (pc: PCInfo) => void;
    handleCancelPc?: (props: ICancelGroupPotentialContraventionDetail) => void;
    handleSkip?: () => void;
    handleChangeForeign?(isForeignPlate: boolean): any;
    handleLookupPlate?(pc: PotentialContraventionLookUp, isLookup?: boolean): any;
    groupPc: PCGroup;
    selectedPc: PCInfo;
    isLast?: boolean;
    isHaveSkippedItem?: boolean;
    cancellationReasons: CancellationReasons[];
    handleSetSkippedToList?: () => void;
    onSelectedPc?(pc: PCInfo): any;
    updatingPlate?: boolean;
    readonly?: boolean;
};
export enum Mode {
    create,
    edit,
}
export default function PCDetail(props: PCDetailProps) {
    const isApproved = props.groupPc.OutCome === OutCome.Approved;
    const isCancelled = props.groupPc.OutCome === OutCome.Cancelled;
    const { groupPcId } = useParams();
    const queryClient = useQueryClient();
    const [commentReason, setCommentReason] = useState<string>('');
    const stageRef = useRef<Konva.Stage>(null);
    const [openPreview, setOpenPreview] = useState<boolean>(false);
    const [loadingPhoto, setLoadingPhoto] = useState<boolean>(true);
    const [photo, setPhoto] = useState<HTMLImageElement>();
    const [scalePhotos, setScalePhotos] = useState<number>(1);
    const [scaleZoomChangeCursor, setScaleZoomChangeCursor] = useState<number>(1);
    const [selectedPhotoItemEvidence, setSelectedPhotoItemEvidence] = useState<CameraPhotoVehicles>(
        {} as CameraPhotoVehicles
    );
    const [selectedEvidencePhotoItem, setSelectedEvidencePhotoItem] = useState<PhotoItem | undefined>({} as PhotoItem);

    const popupChangeEvidence = usePopUp();
    const location = useLocation();
    const { pathname } = location;

    useScrollToTop();

    const pcContext = useContext(PotentialContraventionContext);

    const {
        popupChangePlace,
        contraventionId,
        setIsLoadingLookUp,
        isLoadingLookUp,
        handleClose,
        throttleCancelDuplicate,
        selectedPc,
        setSelectedPc,
        setGroupPcIds,
        setGroupPc,
        conditionExemptionsEnabled,
        groupPc,
        conditionAudit,

        contraventionReason,
        toDate,
        fromDate,
        zonesIds,
        emailVerifier,
        setIsLatestItem,
        searchParams,

        listNotes,
        selectedCamera,
        handleChangeCamera,
    } = pcContext;

    const { cancellationReasons } = props;
    const pc = props.groupPc.PotentialContraventions![0] as PCInfo;
    const step = pc.Step;

    const potentialContravention = props.groupPc.PotentialContraventions?.[0];

    // const cameraPhotosForCameraSolar = potentialContravention?.Camera?.CameraPhotos?.[0];
    const cameraPhotos = (
        props.groupPc.PotentialContraventions?.find((c) => c.CameraId === selectedCamera.Id) as PCInfo
    ).EntryPhotos?.[(potentialContravention as PCInfo)?.EntryPhotos?.length! - 1].CameraPhoto;

    const cameraPhotoBlobName = cameraPhotos?.BlobName;
    const cameraPhotoViewId = cameraPhotos?.ViewId;

    const { setActiveItem, open } = useContext(DrawerContext);

    const imageDimensions = useImagePreviewDimensions({
        maxWidth: openPreview ? RESOLUTIONS['HD'].width : MAX_WIDTH,
        maxHeight: openPreview ? RESOLUTIONS['HD'].height : MAX_HEIGHT,
    });
    const { image, loading, isError } = useImageDimensions(cameraPhotoBlobName);
    const scalePreview = imageDimensions.width / (image?.width ?? 1920);

    const prevGeoZonePoints: GeoZoneCoordinates[][] = props.groupPc.Zone?.Cameras?.flatMap(
        (camera) => camera.GeoZones || selectedCamera.GeoZones || []
    )
        .filter((geoZone) => {
            if (selectedEvidencePhotoItem?.photo?.GeoZoneId) {
                return geoZone.Id === selectedEvidencePhotoItem.photo.GeoZoneId;
            }
            if (cameraPhotoViewId) {
                return geoZone.CameraViewId === cameraPhotoViewId;
            }
            return (
                geoZone.CameraId ===
                (selectedPhotoItemEvidence?.CameraPhoto?.CameraId ||
                    selectedEvidencePhotoItem?.cameraId ||
                    selectedCamera.Id)
            );
        })
        .map(
            (gz) => gz.GeoZoneCoordinates?.sort((a, b) => a.Index - b.Index).concat(gz.GeoZoneCoordinates[0]) || []
        ) as GeoZoneCoordinates[][];

    const prevGeoZones = getGeoZone(scalePreview, prevGeoZonePoints);

    const [loadingReOpen, setLoadingReOpen] = useState(false);
    const [countVerifierNotes, setCountVerifierNotes] = useState<number>(0);

    const conditionContraventionType = selectedPc?.ContraventionType === 'Registered users only.';

    const geoZones = props.groupPc.Zone?.Cameras?.find((gz) => gz.Id === selectedCamera.Id)?.GeoZones?.sort(
        (a, b) => a.Id! - b.Id!
    );

    const grPCDuplicates = _.uniqBy(
        (props.groupPc.PotentialContraventions as PotentialContraventionWithInfo[])
            .map((item) => {
                return item.PCNDuplicate || [];
            })
            .flat()
            .sort((a, b) => {
                if (a.step && b.step) return b.step - a.step;
                return 0;
            }),
        'id' as keyof PCNDuplicate
    );
    const [grDuplicates, setGrDuplicates] = useState<PCNDuplicate[]>(grPCDuplicates);

    const PCNDuplicatesWarning =
        grPCDuplicates.filter((pc) => {
            const duplicateByStella = pc.source === 'Stella';
            const duplicateByECam =
                pc.source === 'ECam' && pc.step === 2 && pc.status !== ContraventionStatus.Cancelled;

            return duplicateByStella || duplicateByECam;
        }) || [];

    const PCNDuplicatesAdditionalInformation =
        grPCDuplicates.filter((pc) => {
            const duplicateByECam = pc.source === 'ECam' && pc.status === ContraventionStatus.Cancelled;
            return duplicateByECam;
        }) || [];

    const getPriorityScore = (statusOutCome: ContraventionStatus, step?: number): number => {
        if (step === 1) {
            if (statusOutCome === ContraventionStatus.InProgress) return 1;
            if (statusOutCome === ContraventionStatus.Cancelled) return 2;
        } else if (step === 2) {
            if (statusOutCome === ContraventionStatus.InProgress) return 3;
            if (statusOutCome === ContraventionStatus.Cancelled) return 4;
            if (statusOutCome === ContraventionStatus.Approved) return 5;
        }
        return -1;
    };

    const duplicatesWithScore =
        (popupChangePlace.open ? grDuplicates : grPCDuplicates)
            ?.filter((dup) => dup.source === 'ECam')
            ?.map((dup) => ({
                ...dup,
                priorityScore: getPriorityScore(dup.status, dup.step),
            })) || [];

    const currentPCScore = {
        id: pc.Id,
        reference: pc.Reference,
        source: 'ECam',
        step: pc.Step,
        status: outComeStatusMapping[pc.OutCome],
        priorityScore: getPriorityScore(outComeStatusMapping[pc.OutCome], pc.Step),
    } as PCNDuplicate & { priorityScore: number };

    const getClosestToTodayItem = (items: typeof duplicatesWithScore) => {
        const now = new Date().getTime();

        return items.reduce((closest, item) => {
            const itemDate = new Date(item.firstIssuedDate!).getTime();
            const closestDate = new Date(closest.firstIssuedDate!).getTime();

            return Math.abs(itemDate - now) < Math.abs(closestDate - now) ? item : closest;
        });
    };

    const filteredDuplicates = (() => {
        const currentScore = currentPCScore.priorityScore;

        const higherPriorityItems = duplicatesWithScore.filter((dup) => dup.priorityScore > currentScore);

        if (higherPriorityItems.length > 0) {
            return [getClosestToTodayItem(higherPriorityItems)];
        }

        return duplicatesWithScore.filter((dup) => dup.priorityScore <= currentScore);
    })();

    const isEVWarning = useMemo(() => {
        return (
            pc?.VehicleFuelType?.toLowerCase().includes('electric') &&
            pc?.ContraventionReasonId === contraventionReasonEV
        );
    }, [pc?.VehicleFuelType, pc?.ContraventionReasonId]);

    const disableButtonApprove =
        selectedPc?.PermitData?.hasPermit ||
        PCNDuplicatesWarning.length > 0 ||
        props.groupPc.NoPCRestriction?.isNoPcRestriction ||
        selectedPc?.PermitData?.permitInfo?.isGlobalPermit ||
        isEVWarning ||
        props?.groupPc?.IsExemptionPlate;

    const popupCancel = useModal();
    const popUpReOpen = usePopUp();
    const popUpSplitAndComplete: UsePopUpReturnType = usePopUp();
    const popUpConfirmGrPcDuplicate = usePopUp();
    const popUpConfirmCancelPcHasPermit = usePopUp();
    const popUpOpenLivePhotos = usePopUp();

    const navigate = useNavigate();

    const breadcrumbs: IBreadCrumbs[] = [
        {
            title: pc.IsObscuredPlate ? 'Bespoke verification' : 'Verification queue',
            href: `/${pc.IsObscuredPlate ? 'bespoke-' : ''}verification${location.search}`,
        },
        { title: pc.Zone?.PublicName || '' },
    ];

    const [openPreviewIMG, setOpenPreviewIMG] = useState(false);

    const cancellationReasonAutocomp = useStyledAutocomplete({
        list: {
            options: cancellationReasons,
            isFiltered(option, searchText) {
                return option.Reason.toLowerCase().includes(searchText.toLocaleLowerCase());
            },
        },
        dependencyList: [cancellationReasons],
    });

    const handleCancelVerification = (cancelReason: FormCancelReasonValues) => {
        const _filterCancelVerification: ICancelGroupPotentialContraventionDetail = {
            Id: props.groupPc.Id!,
            CancellationReasonId: cancelReason.cancellationReason.Id!,
            CancellationNotes: cancelReason.comment,
            GroupPcCancellationRelation: cancelReason.data
                ? {
                      Plate: cancelReason.data?.licensePlate!,
                      Source: cancelReason.data?.source! ?? 'ECam',
                      GroupPotentialContraventionId: groupPc?.Id!,
                      ReferenceId: cancelReason.data.source !== undefined ? pc?.Id! : undefined,
                  }
                : undefined,
        };
        props.handleCancelPc?.(_filterCancelVerification);
    };

    const handleLookUp = async (_pc: PCInfo) => {
        setIsLoadingLookUp(true);
        await pcController
            .lookUp(_pc.Plate, { GroupPotentialContraventionId: props.groupPc?.Id! })
            .then(async (res) => {
                const isChanged =
                    _pc.VehicleColor !== res.Color ||
                    _pc.VehicleMake !== res.Make ||
                    _pc.VehicleModel !== res.Model ||
                    _pc.VehicleFuelType !== res.FuelType;

                queryClient.invalidateQueries(['trailAuditEventLogPCN']);

                if (isChanged) {
                    const _vehicle: PotentialContraventionLookUp = {
                        ...res,
                    };
                    props.handleLookupPlate?.(_vehicle, true);
                } else {
                    pushSuccess('Filled successfully');
                }
            })
            .catch((err) => {})
            .finally(() => {
                setIsLoadingLookUp(false);
            });
    };

    const handleReOpen = () => {
        setLoadingReOpen(true);
        potentialGroupContraventionController
            .doReOpenGroupPotentialContravention({ Id: props.groupPc?.Id! })
            .then((res) => {
                popUpReOpen.onClose();
                pushSuccess('Re-open PCN successfully');
            })
            .finally(() => {
                setLoadingReOpen(false);
                navigate(-1);
            });
    };

    useEffect(() => {
        setActiveItem(DrawerPage.Verification);
    }, [pc.IsObscuredPlate]);

    const inprogressPCs =
        props.groupPc.PotentialContraventions?.filter((pc) => pc.OutCome === OutCome.InProgress) || [];
    const approvedPCs = props.groupPc.PotentialContraventions?.filter((pc) => pc.OutCome === OutCome.Approved) || [];
    const canceledPCs = props.groupPc.PotentialContraventions?.filter((pc) => pc.OutCome === OutCome.Cancelled) || [];

    const inprogressPcCount = inprogressPCs.length;
    const approvePcCount = approvedPCs.length;
    const cancelPcCount = canceledPCs.length;

    const [selectedTab, setSelectedTab] = useState(1);

    const tabs = [
        {
            id: 1,
            title: `In progress (${inprogressPcCount})`,
            icon: <ApproveIcon />,
            isShow: inprogressPcCount > 0,
        },
        {
            id: 2,
            title: `Approve (${approvePcCount})`,
            icon: <ApproveIcon />,
            isShow: approvePcCount > 0,
        },
        {
            id: 3,
            title: `Cancel (${cancelPcCount})`,
            icon: <CancelIcon />,
            isShow: cancelPcCount > 0,
        },
    ];

    useEffect(() => {
        if (!!inprogressPcCount) setSelectedTab(1);
        else if (!!approvePcCount) setSelectedTab(2);
        else setSelectedTab(3);
    }, [approvePcCount, inprogressPcCount]);

    const [idAudits, setIdAudits] = useState<number[]>([]);

    const getIdsAudit = async () => {
        const _filter: IGetGroupPotentialContraventionsCancelled = {
            CancellationReason: Number(contraventionReason),
            CreatedFromDate: moment(fromDate).startOf('day').toDate(),
            CreatedToDate: moment(toDate).endOf('day').toDate(),
            VerifierEmail: emailVerifier ?? undefined,
            filter: {
                ZoneId: zonesIds,
            },
        };
        await potentialGroupContraventionController
            .getListCancelledNotAuditIds(_filter)
            .then((res) => {
                setIdAudits(res);
            })
            .catch((err) => {
                pushError(err.response.data.message);
            });
    };

    useEffect(() => {
        if (conditionAudit && !props?.groupPc?.VerificationAudit) {
            getIdsAudit();
        }
    }, [conditionAudit]);

    const handleNextAuditItems = () => {
        const currentIdIndex = idAudits.findIndex((id) => id === Number(groupPcId));
        const nextIndex = currentIdIndex + 1;

        if (nextIndex < idAudits.length) {
            const nextId = idAudits[nextIndex];
            navigate(`/overview-verification/${nextId}/audit?${searchParams.toString()}`, { replace: true });
        } else {
            setIsLatestItem(true);
            pushWarning('This item is the last item in the list');
            backdrop.setTrue();
            setTimeout(() => {
                backdrop.setFalse();
                navigate(`/verification`);
            }, 2000);
            return;
        }
    };

    const conditionPathnameNotAudit = isCancelled && !conditionAudit;
    const conditionPathnameVerification = pathname.includes(`/verification/contravention/${props.groupPc.Id}`);

    const backdrop = useBackdrop();

    const handleAuditAndSkipPcPage = async () => {
        backdrop.setTrue();
        await auditVerificationHTTPController
            .auditAndSkip({ GroupPcId: props.groupPc?.Id! })
            .then((_) => {
                queryClient.invalidateQueries(['trailAuditEventLogPCN']);
                pushSuccess('Audit and skip successfully');
                handleNextAuditItems();
            })
            .catch((err) => {
                pushError(err);
            })
            .finally(() => {
                backdrop.setFalse();
            });
    };

    const handleAuditAndApprovePcPage = async () => {
        backdrop.setTrue();
        await auditVerificationHTTPController
            .auditAndApprove({ GroupPcId: props.groupPc?.Id!, PotentialContraventionId: pc.Id! })
            .then((res) => {
                if ((res as PermitData).hasPermit) {
                    pushWarning('Has permit');
                    setSelectedPc((prev) => ({
                        ...prev!,
                        PermitData: res as PermitData,
                    }));
                    backdrop.setFalse();
                    return;
                }
                queryClient.invalidateQueries(['trailAuditEventLogPCN']);
                pushSuccess('Audit and approve successfully');
                handleNextAuditItems();
            })
            .catch((err) => {
                pushError(err);
            })
            .finally(() => {
                backdrop.setFalse();
            });
    };

    useEffect(() => {
        if (pathname === `/verification/contravention/${props.groupPc.Id}/audit`) {
            navigate(-1);
        }
    }, [pathname]);

    const [valueTabs, setValueTabs] = useState<number>(0);

    const handleChangeTabs = (event: React.SyntheticEvent, newValue: number) => {
        setValueTabs(newValue);
    };

    const menuTabs: TabConfig[] = [
        {
            index: 1,
            label: `Geo-zone (${geoZones?.length ?? 0})`,
        },
        {
            index: 2,
            label: `Verifier note (${listNotes.rows?.length})`,
        },
        {
            index: 3,
            label: `PCN note (${countVerifierNotes ?? 0})`,
        },
        ...(PCNDuplicatesAdditionalInformation.length > 0
            ? [
                  {
                      index: 4,
                      label: `List related canceled PCs (${PCNDuplicatesAdditionalInformation.length})`,
                  },
              ]
            : []),
        {
            index: 5,
            label: 'Event log',
        },
    ];

    const isAuditCondition = pathname.includes('audit') && !groupPc?.VerificationAudit && !props.isLast;
    const isReadOnlyCondition = !props.readonly && !isApproved && !isCancelled && !props.isLast;

    const [collapseNotifications, setCollapseNotifications] = useState<boolean>(true);

    const handleCollapseNotifications = () => {
        setCollapseNotifications((prev) => !prev);
    };

    const hasCamerasNote = props.groupPc.Zone?.Cameras?.some((camera) => !!camera?.Notes);

    const notificationCount = [
        hasCamerasNote ? 1 : 0,
        selectedPc?.PermitData?.hasPermit,
        selectedPc?.PermitData?.permitInfo?.isGlobalPermit,
        props?.groupPc?.VerificationAudit,
        props.groupPc?.PotentialContraventions?.[0]?.CancellationReasonId ||
            PCNDuplicatesWarning?.length > 0 ||
            (filteredDuplicates.length > 0 && step === 1),
        props.groupPc.NoPCRestriction?.isNoPcRestriction,
        isEVWarning,
        props?.groupPc?.IsExemptionPlate,
    ].filter(Boolean)?.length;

    const { X1, X2, X3, X4, Y1, Y2, Y3, Y4 } = selectedPhotoItemEvidence ?? {};
    const rootImageWidth = image?.width || 1920;
    const scaleSize = rootImageWidth / 1280;

    const initialCropArea: CropArea | null = convertToCropArea({
        X1: X1! / scaleSize,
        X2: X2! / scaleSize,
        X3: X3! / scaleSize,
        X4: X4! / scaleSize,
        Y1: Y1! / scaleSize,
        Y2: Y2! / scaleSize,
        Y3: Y3! / scaleSize,
        Y4: Y4! / scaleSize,
    });

    useEffect(() => {
        if (photo) {
            const naturalWidth = photo.naturalWidth;
            const naturalHeight = photo.naturalHeight;
            const scaleX = 1280 / naturalWidth;
            const scaleY = 720 / naturalHeight;
            const initialScale = Math.min(scaleX, scaleY);
            setScalePhotos(initialScale);
        }
    }, [photo]);

    useEffect(() => {
        if (!selectedPhotoItemEvidence.CameraPhoto?.BlobName) {
            setLoadingPhoto(false);
            return;
        }
        const img = new window.Image();
        img.src = appConfig.gateway.blobURL + selectedPhotoItemEvidence.CameraPhoto?.BlobName;

        img.onload = () => {
            setPhoto(img);
            setLoadingPhoto(false);
        };

        img.onerror = () => {
            setLoadingPhoto(false);
        };
    }, [selectedPhotoItemEvidence.CameraPhoto?.BlobName]);

    const handleTransform = (e: any) => {
        setScaleZoomChangeCursor(e.instance.transformState.scale);
    };

    const {
        image: imagePreviewEvidence,
        loading: loadingPreviewEvidence,
        isError: isErrorPreviewEvidence,
    } = useImageDimensions(selectedPhotoItemEvidence.CameraPhoto?.BlobName);

    const handleOpenPopUpGrPcDuplicate = () => {
        popUpConfirmGrPcDuplicate.setTrue();
    };

    const hasAnyLowerOrEqualPriority = duplicatesWithScore.some(
        (dup) => dup.priorityScore > currentPCScore.priorityScore
    );

    const handleConfirmGrPcDuplicate = () => {
        if (!pc) return;

        potentialGroupContraventionController
            .doGroupContraventionDuplicate({ PotentialContraventionId: pc.Id! })
            .then(async () => {
                pushSuccess('Group PCNs duplicate successfully!');
                popUpConfirmGrPcDuplicate.onClose();

                await potentialGroupContraventionController
                    .getGroupPotentialContraventionIds({ Step: step, ZoneId: pc.ZoneId })
                    .then(async (res) => {
                        setGroupPcIds(res.Ids.map((id) => ({ Id: id })));
                        if (hasAnyLowerOrEqualPriority) {
                            props.handleSkip?.();
                            return;
                        }
                        backdrop.setTrue();
                        await potentialGroupContraventionController
                            .getGroupPotentialContravention(contraventionId)
                            .then(async (res) => {
                                const _res: GroupPotentialContraventions = {
                                    ...res,
                                    PotentialContraventions: _.orderBy(res.PotentialContraventions, (pc) => -pc.Step),
                                };
                                setGroupPc(_res);
                                setSelectedPc(_res.PotentialContraventions![0] as PCInfo);
                            })
                            .catch((err) => navigate('/verification'))
                            .finally(() => {
                                backdrop.setFalse();
                            });
                    })
                    .catch((_) => {});
            });
    };

    const handleOpenPopUpCancelPcHasPermit = () => {
        popUpConfirmCancelPcHasPermit.setTrue();
    };

    const handleConfirmCancelPcHasPermit = () => {
        if (!groupPc || !cancellationReasons) return;
        popUpConfirmCancelPcHasPermit.onClose();
        const idReason = cancellationReasons.find((c) => c.Id === 17)?.Id;

        const _filter: ICancelGroupPotentialContraventionDetail = {
            Id: groupPc.Id!,
            CancellationReasonId: idReason!,
            CancellationNotes: '',
        };
        props.handleCancelPc?.(_filter);
    };

    const handleSetGrDuplicates = (duplicates: PCNDuplicate[]) => {
        setGrDuplicates(duplicates);
    };

    const handleSelectEvidencePhotoItem = (evidencePhoto?: PhotoItem) => {
        setSelectedEvidencePhotoItem(evidencePhoto);
    };

    const camerasAutocomplete = useStyledAutocomplete({
        list: {
            options: props.groupPc.Zone?.Cameras || [],
            isFiltered(option, searchText) {
                return option.Name.toLowerCase().includes(searchText.toLowerCase());
            },
        },
        dependencyList: [props.groupPc.Zone?.Cameras],
    });

    return (
        <Stack direction="column">
            {!props.isLast && (
                <Stack py={8}>
                    <Box
                        position={'fixed'}
                        top={0}
                        zIndex={10}
                        width={'100%'}
                        bgcolor={'white'}
                        paddingTop={12}
                        paddingBottom={'2px'}
                        gap={1}
                    >
                        <Stack direction="row" justifyContent="space-between" alignItems="center">
                            <Stack direction="row" justifyContent={'start'} gap={2} ml={1}>
                                <Typography variant="h3">{pc.Zone?.PublicName}</Typography>

                                {!!inprogressPcCount && (
                                    <Box
                                        sx={{
                                            padding: '5px 16px',
                                            background: '#E8F5E9',
                                            color: '#2E7D32',
                                            borderRadius: '4px',
                                        }}
                                    >
                                        {`Step ${step} - ${
                                            props?.groupPc?.VerificationAudit ? 'In progress & Audited' : 'In progress'
                                        }`}
                                    </Box>
                                )}

                                {isApproved && (
                                    <Box
                                        sx={{
                                            padding: '5px 16px',
                                            background: '#E8F5E9',
                                            color: '#2E7D32',
                                            borderRadius: '4px',
                                        }}
                                    >
                                        {`Step ${step} - ${
                                            props?.groupPc?.VerificationAudit ? 'Approved & Audited' : 'Approved'
                                        }`}
                                    </Box>
                                )}

                                {isCancelled && (
                                    <Box
                                        sx={{
                                            padding: '5px 16px',
                                            background: '#FFF1F0',
                                            color: '#E01B00',
                                            borderRadius: '4px',
                                        }}
                                    >
                                        {`Step ${step} - ${
                                            props?.groupPc?.VerificationAudit ? ' Cancelled & Audited' : 'Cancelled'
                                        }`}
                                    </Box>
                                )}
                            </Stack>
                            {conditionPathnameNotAudit &&
                                !props?.groupPc?.VerificationAudit &&
                                !conditionPathnameVerification && (
                                    <Button
                                        variant="contained"
                                        sx={{ minWidth: 130, position: 'fixed', zIndex: 10, right: 30 }}
                                        onClick={() => {
                                            navigate(`audit?${searchParams.toString()}`);
                                        }}
                                    >
                                        Audit
                                    </Button>
                                )}
                        </Stack>
                        <Stack mt={1} ml={1}>
                            <BreadCrumbs breadcrumbs={breadcrumbs} />
                        </Stack>
                    </Box>

                    {/* Notifications - Warning */}
                    {notificationCount !== 0 && (
                        <Stack border={'1px solid #DDDDDD'} borderRadius={2} mt={2} p={2}>
                            <Stack
                                width={'100%'}
                                direction={'row'}
                                alignItems={'center'}
                                onClick={handleCollapseNotifications}
                                sx={{
                                    cursor: 'pointer',
                                    ':hover .MuiIconButton-root': {
                                        bgcolor: '#0000000a',
                                    },
                                    ':active .MuiIconButton-root': {
                                        bgcolor: '#0000001f',
                                    },
                                }}
                            >
                                <Typography variant="h5">Notifications ({notificationCount})</Typography>
                                <Box flex={1} textAlign={'end'}>
                                    <IconButton>
                                        <ArrowDownButtonEndIcon
                                            style={{
                                                transition: 'transform 0.3s ease',
                                                transform: `rotate(${collapseNotifications ? -180 : 0}deg)`,
                                            }}
                                        />
                                    </IconButton>
                                </Box>
                            </Stack>

                            <Collapse in={collapseNotifications} sx={{ mt: collapseNotifications ? 2 : 0 }}>
                                <Fade in={collapseNotifications} timeout={500}>
                                    <Stack direction={'column'} spacing={2}>
                                        {props?.groupPc?.VerificationAudit && (
                                            <Stack
                                                borderRadius={'4px'}
                                                sx={{
                                                    px: 2,
                                                    py: 1,
                                                    background: '#E8F5E9 !important',
                                                }}
                                                borderLeft={`3px solid ${color.success} `}
                                            >
                                                <Stack direction={'row'} spacing={1} alignItems={'center'}>
                                                    <AuditorIcon />
                                                    <Typography variant="body1" color="initial">
                                                        This case has been audited
                                                    </Typography>
                                                </Stack>
                                                <Stack mt={'4px'} direction={'row'} spacing={1} alignItems={'center'}>
                                                    <Typography lineHeight={1}>
                                                        Auditor:
                                                        <Typography pl={'5px'} variant="caption">
                                                            {props.groupPc.VerificationAudit.AuditorEmail.split(
                                                                '@'
                                                            )[0] || ''}
                                                        </Typography>
                                                    </Typography>
                                                    <Divider
                                                        orientation="vertical"
                                                        flexItem
                                                        sx={{
                                                            borderRightWidth: 1,
                                                            borderColor: color.grey600,
                                                        }}
                                                    />
                                                    <Typography>
                                                        Date audited:
                                                        <Typography pl={'5px'} variant="caption">
                                                            {formatUKDateTime(
                                                                props?.groupPc?.VerificationAudit?.Created
                                                            )}
                                                        </Typography>
                                                    </Typography>
                                                </Stack>
                                            </Stack>
                                        )}

                                        {hasCamerasNote && (
                                            <Fade in={true}>
                                                <Stack
                                                    sx={{
                                                        px: 2,
                                                        py: 1,
                                                        background: '#E8F5E9',
                                                        borderRadius: 1,
                                                        wordBreak: 'break-word',
                                                    }}
                                                >
                                                    {props.groupPc.Zone?.Cameras?.map(
                                                        (camera) =>
                                                            camera?.Notes && (
                                                                <Typography key={camera?.Id}>
                                                                    <Link to={`/cameras/${camera.Id}`} target="_blank">
                                                                        {camera?.Name}
                                                                    </Link>
                                                                    : {camera?.Notes}
                                                                </Typography>
                                                            )
                                                    )}
                                                </Stack>
                                            </Fade>
                                        )}

                                        {(props.groupPc?.PotentialContraventions?.[0]?.CancellationReasonId ||
                                            PCNDuplicatesWarning?.length > 0 ||
                                            (filteredDuplicates?.length > 0 && step === 1)) && (
                                            <Stack
                                                borderRadius={'4px'}
                                                sx={{
                                                    p: 2,
                                                    background: '#FFF1F9',
                                                }}
                                            >
                                                <DuplicatePCDetail
                                                    cancellationNotes={
                                                        props.groupPc.PotentialContraventions?.[0].CancellationNotes
                                                    }
                                                    reason={
                                                        props.groupPc.PotentialContraventions?.[0].Cancellation?.Reason
                                                    }
                                                    pcnDuplicatesWarning={PCNDuplicatesWarning}
                                                    handleOpenPopUp={handleOpenPopUpGrPcDuplicate}
                                                    currentStep={step}
                                                    pcnGroupingDuplicatesWarning={filteredDuplicates}
                                                />
                                            </Stack>
                                        )}

                                        {props.groupPc.NoPCRestriction?.isNoPcRestriction && (
                                            <OrangeStack gap={1} direction={'row'} alignItems={'center'}>
                                                <WarningIcon />
                                                <Typography>{notesMO}</Typography>
                                            </OrangeStack>
                                        )}

                                        {selectedPc?.PermitData && (
                                            <PermitDuplicate
                                                permitData={selectedPc?.PermitData}
                                                handleOpenPopUp={handleOpenPopUpCancelPcHasPermit}
                                            />
                                        )}

                                        {selectedPc?.PermitData?.permitInfo?.isGlobalPermit && (
                                            <OrangeStack mt={2} direction={'column'} gap={1}>
                                                Has global permit
                                            </OrangeStack>
                                        )}

                                        {isEVWarning && (
                                            <OrangeStack mt={2} direction={'row'} alignItems={'center'} gap={1}>
                                                <WarningIcon />
                                                <Typography>
                                                    This vehicle is an EV and is correctly parked in an EV bay.
                                                </Typography>
                                            </OrangeStack>
                                        )}

                                        {props?.groupPc?.IsExemptionPlate && (
                                            <OrangeStack>
                                                <Typography lineHeight={1}>
                                                    This VRN has an active exemption and is listed in the Exemption Permit list.
                                                </Typography>
                                            </OrangeStack>
                                        )}
                                    </Stack>
                                </Fade>
                            </Collapse>
                        </Stack>
                    )}

                    {/* Warning Note */}
                    {listNotes.rows && listNotes.rows?.length > 0 && (
                        <Stack borderRadius={'4px'} mt={2} sx={{ px: 2, py: 1 }} bgcolor={color.gold200}>
                            <Fade in={true}>
                                <Stack direction={'row'} spacing={1}>
                                    <Typography>
                                        <span style={{ fontWeight: 600 }}>Note:</span>{' '}
                                        <span
                                            style={{
                                                fontStyle: 'italic',
                                                wordWrap: 'break-word',
                                                whiteSpace: 'pre-wrap',
                                                wordBreak: 'break-word',
                                            }}
                                        >
                                            {listNotes.rows?.[0].Notes || ''}
                                        </span>
                                    </Typography>
                                </Stack>
                            </Fade>
                        </Stack>
                    )}

                    <Stack direction={'row'} gap={3} width={'100%'} mt={2}>
                        <DetailInfoSection
                            icon={<ICDetails />}
                            title="Details"
                            action={
                                !conditionPathnameNotAudit && (
                                    <Button
                                        variant="orangeContained"
                                        sx={{ px: 1, py: 0.5, position: 'absolute', right: 10, fontSize: 12 }}
                                        onClick={() => {
                                            handleLookUp(pc);
                                        }}
                                        disabled={isLoadingLookUp}
                                    >
                                        {isLoadingLookUp ? 'Looking up...' : 'Look up'}
                                    </Button>
                                )
                            }
                            content={
                                <>
                                    <DetailInfoItem leftContent="Vehicle Info Source" rightContent={pc.Plate} />
                                    <DetailInfoItem leftContent="Make" rightContent={pc.VehicleMake} />
                                    <DetailInfoItem leftContent="Model" rightContent={pc.VehicleModel} />
                                    <DetailInfoItem leftContent="Color" rightContent={pc.VehicleColor} />
                                    <DetailInfoItem leftContent="Fuel Type" rightContent={pc.VehicleFuelType} />
                                </>
                            }
                        />
                        <DetailInfoSection
                            icon={<ICNote />}
                            title="Contravention"
                            content={
                                <>
                                    <DetailInfoItem leftContent="Location" rightContent={pc.Zone?.Location?.Name} />
                                    <DetailInfoItem leftContent="Zone" rightContent={pc.Zone?.PublicName} />
                                    <DetailInfoItem
                                        leftContent="Contravention type"
                                        rightContent={pc.ContraventionType}
                                    />
                                </>
                            }
                        />
                    </Stack>

                    <Box mt={2}>
                        <BaseEnhancedTabs
                            tabs={menuTabs}
                            value={valueTabs}
                            onChange={handleChangeTabs}
                            minWidth={'10%'}
                        />
                        {menuTabs.map((tab, index) => (
                            <CustomTabPanel value={valueTabs} index={index} key={index}>
                                {tab.index === 1 && (
                                    <>
                                        <DetailInfoSection
                                            borderRadius={'0px 8px 8px 8px'}
                                            icon={<PiCubeFocusThin fontSize={28} />}
                                            title="Geo-zones"
                                            action={
                                                <Stack direction={'row'} spacing={1} alignItems={'center'}>
                                                    <Tooltip arrow title="View geo-zone" placement="top">
                                                        <Button
                                                            variant="contained"
                                                            sx={{ minWidth: 25, height: 25, py: 1, px: 0.5 }}
                                                            onClick={() => {
                                                                setOpenPreview(true);
                                                                handleChangeCamera(selectedCamera);
                                                            }}
                                                        >
                                                            <BiSearchAlt />
                                                        </Button>
                                                    </Tooltip>
                                                    <Tooltip arrow title="View camera information" placement="top">
                                                        <Link
                                                            to={`/cameras/${selectedCamera.Id}`}
                                                            style={{ textDecoration: 'none' }}
                                                            target="_blank"
                                                        >
                                                            <Button
                                                                variant="contained"
                                                                sx={{ minWidth: 25, height: 25, py: 1, px: 0.5 }}
                                                            >
                                                                <CameraIcon
                                                                    width={14}
                                                                    height={14}
                                                                    fill={color.textPrimary}
                                                                />
                                                            </Button>
                                                        </Link>
                                                    </Tooltip>
                                                </Stack>
                                            }
                                            content={<PCGeoZonesDetail geoZones={geoZones} />}
                                            selectedCamera={selectedCamera}
                                            camerasAutocomplete={camerasAutocomplete}
                                            handleChangeCamera={handleChangeCamera}
                                        />
                                        <PreviewImageWithGeoZone
                                            open={openPreview}
                                            onClose={() => setOpenPreview(false)}
                                            imgSrc={image}
                                            scaleX={scalePreview}
                                            scaleY={scalePreview}
                                            geoZones={prevGeoZones}
                                            widthPreview={imageDimensions.width}
                                            heightPreview={imageDimensions.height}
                                        />
                                    </>
                                )}

                                {tab.index === 2 && <NoteOPs camerasAutocomplete={camerasAutocomplete} />}

                                {tab.index === 3 && <NoteVerifier onCountPCNNote={setCountVerifierNotes} />}

                                {tab.index === 4 && (
                                    <ListPCNDuplicatesAdditionalInformation
                                        pcnDuplicatesAdditionalInformation={PCNDuplicatesAdditionalInformation}
                                        pcId={pc.Zone?.Id}
                                    />
                                )}

                                {tab.index === 5 && <RecordedPCNEventLogScreen />}
                            </CustomTabPanel>
                        ))}
                    </Box>

                    <Box mt={4}>
                        <Box border={`1px solid ${color.grey300}`} borderRadius={'8px'} padding={2}>
                            <Stack
                                width={
                                    open || pc.IsObscuredPlate || props.readonly
                                        ? '100%'
                                        : open && !pc.IsObscuredPlate
                                          ? '85%'
                                          : '75%'
                                }
                                margin={'0 auto'}
                                direction={'row'}
                                justifyContent={'space-between'}
                                alignItems={'center'}
                            >
                                <Typography variant="h5">
                                    {props.readonly
                                        ? 'All the evidence photos'
                                        : 'Please select from the evidence photos below:'}
                                </Typography>
                                <Stack direction={'row'} spacing={1} alignItems={'center'}>
                                    <Button
                                        variant="outlinedGreen"
                                        sx={{
                                            minWidth: '150px',
                                            fontSize: 13,
                                            padding: '8px 12px',
                                        }}
                                        onClick={() => {
                                            popUpOpenLivePhotos.setTrue();
                                        }}
                                    >
                                        Open live photos
                                    </Button>

                                    <PopUpOpenLivePhotos
                                        {...popUpOpenLivePhotos}
                                        selectedPc={selectedPc ?? ({} as PotentialContraventionWithInfo)}
                                    />

                                    {(isAuditCondition || isReadOnlyCondition) && (
                                        <Button
                                            variant="contained"
                                            sx={{
                                                minWidth: '100px',
                                                fontSize: 13,
                                                padding: '8px 12px',
                                            }}
                                            onClick={() => popupChangeEvidence.setTrue()}
                                        >
                                            Change evidence
                                        </Button>
                                    )}
                                </Stack>
                            </Stack>

                            {props.readonly && (
                                <Stack direction="row" gap={1} mt={1}>
                                    {tabs
                                        .filter((t) => t.isShow)
                                        .map((item, index) => {
                                            return (
                                                <Stack
                                                    key={index + 'z'}
                                                    direction="row"
                                                    alignItems="center"
                                                    justifyContent="center"
                                                    sx={{
                                                        width: 140,
                                                        p: 1,
                                                        background: selectedTab === item.id ? '#E8F5E9' : '#FAFAFA',
                                                        borderRadius: '8px 8px 0px 0px',
                                                        color:
                                                            selectedTab === item.id
                                                                ? theme.palette.success.main
                                                                : color.grey600,
                                                        cursor: 'pointer',
                                                        transition: '.2s',
                                                    }}
                                                    gap={1}
                                                    onClick={() => {
                                                        setSelectedTab(item.id);
                                                    }}
                                                >
                                                    {item.icon}
                                                    <Typography
                                                        variant="body1"
                                                        color={
                                                            selectedTab === item.id
                                                                ? theme.palette.success.main
                                                                : color.grey600
                                                        }
                                                        sx={{ userSelect: 'none', lineHeight: 1 }}
                                                    >
                                                        {item.title}
                                                    </Typography>
                                                </Stack>
                                            );
                                        })}
                                </Stack>
                            )}

                            <Stack
                                flexBasis={1}
                                spacing={3}
                                alignItems={'center'}
                                sx={!props.readonly ? { mt: 2 } : { border: '1px solid #ddd', padding: 2 }}
                            >
                                {(selectedTab === 1
                                    ? inprogressPCs
                                    : selectedTab === 2
                                      ? approvedPCs
                                      : canceledPCs
                                ).map((pc, index) => {
                                    return (
                                        <EvidencePhotoGroup
                                            key={pc.Id}
                                            pc={pc as PCInfo}
                                            cancellationReasons={cancellationReasons}
                                            prevGeoZones={prevGeoZones}
                                            selected={pc.Id === props.selectedPc?.Id}
                                            onSelect={props.onSelectedPc}
                                            readonly={props.readonly}
                                            VerificationAudit={props?.groupPc?.VerificationAudit}
                                            handleCancelPc={props.handleCancelPc}
                                            selectedEvidencePhotoItem={selectedEvidencePhotoItem!}
                                            handleSelectEvidencePhotoItem={handleSelectEvidencePhotoItem}
                                            popUpOpenLivePhotos={popUpOpenLivePhotos}
                                        />
                                    );
                                })}

                                <Dialog
                                    open={openPreviewIMG}
                                    onClose={() => {
                                        setOpenPreviewIMG(false);
                                    }}
                                    PaperProps={{
                                        sx: {
                                            minWidth: 1280,
                                            minHeight: 720,
                                        },
                                    }}
                                >
                                    <div>
                                        <img style={{ width: 1280, height: 1280 * 0.5625 }} src={''} alt="Zoomable" />
                                    </div>
                                </Dialog>
                            </Stack>
                        </Box>
                    </Box>
                </Stack>
            )}

            {isAuditCondition && (
                <Stack position={'fixed'} bottom={0} zIndex={1} width={'100%'} bgcolor={'white'}>
                    <Stack direction={'row'} py={2} justifyContent={'space-between'}>
                        <Stack direction={'row'} spacing={2} alignItems={'center'}>
                            <LoadingButton
                                sx={{
                                    minWidth: '150px',
                                    justifyContent: props.updatingPlate ? 'space-between' : 'center',
                                }}
                                color="secondary"
                                onClick={() => {
                                    popupChangePlace.handleOpen();
                                    setGrDuplicates(grPCDuplicates);
                                }}
                                loading={props.updatingPlate}
                                loadingPosition="start"
                                startIcon={props.updatingPlate ? <></> : undefined}
                                variant="orangeContained"
                            >
                                <span>Change plate</span>
                            </LoadingButton>
                            <Button
                                onClick={() => {
                                    handleLookUp(pc);
                                }}
                                sx={{
                                    minWidth: '150px',
                                    backgroundColor: color.darkSecondary,
                                    color: color.white,
                                    '&:hover': {
                                        backgroundColor: '#17A2B8',
                                    },
                                }}
                                disabled={isLoadingLookUp}
                            >
                                {isLoadingLookUp ? 'Looking up...' : 'Look up'}
                            </Button>
                        </Stack>
                        <PopUpSplitAndComplete
                            {...popUpSplitAndComplete}
                            popupCancel={popupCancel}
                            cancelPc={{
                                CancellationNotes: commentReason ?? undefined,
                                CancellationReasonId: 2,
                                Id: props.groupPc.Id!,
                            }}
                            pc={pc}
                        />
                        <AuditApproveButtons
                            handleAuditAndSkip={handleAuditAndSkipPcPage}
                            grId={props.groupPc?.Id!}
                            pcId={pc.Id!}
                            handleAuditAndApprove={handleAuditAndApprovePcPage}
                            selectedPc={selectedPc!}
                            idAudits={idAudits}
                            isNoPCRestriction={props.groupPc.NoPCRestriction?.isNoPcRestriction}
                            isEVWarning={isEVWarning}
                            isExemptionPlate={props.groupPc.IsExemptionPlate}
                        />
                        <ModalChangePlate
                            updatingPlate={props.updatingPlate}
                            selectedPc={props.selectedPc}
                            {...popupChangePlace}
                            popupChangePlace={popupChangePlace}
                        />
                    </Stack>
                </Stack>
            )}

            {isReadOnlyCondition && (
                <Stack position={'fixed'} bottom={0} zIndex={1} width={'100%'} bgcolor={'white'}>
                    <Stack direction={'row'} py={2} justifyContent={'space-between'}>
                        <Stack gap={2} direction="row">
                            <Button
                                variant="errorContained"
                                sx={{ minWidth: '150px' }}
                                onClick={() => popupCancel.handleOpen()}
                            >
                                Cancel
                            </Button>

                            <LoadingButton
                                sx={{
                                    minWidth: '150px',
                                    justifyContent: props.updatingPlate ? 'space-between' : 'center',
                                }}
                                color="secondary"
                                onClick={() => {
                                    popupChangePlace.handleOpen();
                                    setGrDuplicates(grPCDuplicates);
                                }}
                                loading={props.updatingPlate}
                                loadingPosition="start"
                                startIcon={props.updatingPlate ? <></> : undefined}
                                variant="orangeContained"
                            >
                                <span>Change plate</span>
                            </LoadingButton>

                            <Button
                                onClick={() => {
                                    handleLookUp(pc);
                                }}
                                sx={{
                                    minWidth: '150px',
                                    backgroundColor: color.darkSecondary,
                                    color: color.white,
                                    '&:hover': {
                                        backgroundColor: '#17A2B8',
                                    },
                                }}
                                disabled={isLoadingLookUp}
                            >
                                {isLoadingLookUp ? 'Looking up...' : 'Look up'}
                            </Button>
                        </Stack>
                        <PopUpSplitAndComplete
                            {...popUpSplitAndComplete}
                            popupCancel={popupCancel}
                            cancelPc={{
                                CancellationNotes: commentReason ?? undefined,
                                CancellationReasonId: 2,
                                Id: props.groupPc.Id!,
                            }}
                            pc={pc}
                        />
                        <ModalCancellationReasons
                            {...popupCancel}
                            cancellationReasonAutocomplete={cancellationReasonAutocomp}
                            handleCancelPC={handleCancelVerification}
                            popUpSplitAndComplete={popUpSplitAndComplete}
                            commentReason={(comment) => {
                                setCommentReason(comment);
                            }}
                            groupPc={groupPc}
                            isEVWarning={isEVWarning}
                            selectedCamera={selectedCamera}
                        />

                        <ModalChangePlate
                            updatingPlate={props.updatingPlate}
                            selectedPc={props.selectedPc}
                            {...popupChangePlace}
                            popupChangePlace={popupChangePlace}
                        />

                        <Stack position={'fixed'} right={30} direction={'row'} gap={2}>
                            <FormControlLabel
                                sx={{ '&.MuiFormControlLabel-root': { margin: 0 } }}
                                checked={!!pc.IsForeign}
                                control={
                                    <BaseCheckbox
                                        onChange={(_, checked) => {
                                            props.handleChangeForeign?.(checked);
                                        }}
                                    />
                                }
                                label={
                                    <Typography ml={0.5} mt={0.3}>
                                        Foreign plate
                                    </Typography>
                                }
                            />
                            <Button
                                variant="contained"
                                sx={{ minWidth: '150px' }}
                                disabled={disableButtonApprove}
                                onClick={() => props.handleApprove?.(props.selectedPc)}
                            >
                                Approve
                            </Button>
                            <Button variant="cancel" sx={{ minWidth: '150px' }} onClick={() => props.handleSkip?.()}>
                                Skip
                            </Button>
                        </Stack>
                    </Stack>
                </Stack>
            )}

            <PopupChangeEvidence
                {...popupChangeEvidence}
                pc={pc}
                onSetSelectedPhotos={setSelectedPhotoItemEvidence}
                onPreviewChange={(open) => {
                    setOpenPreview(open);
                }}
            />

            <PopUpWarning
                {...popUpConfirmGrPcDuplicate}
                title="Confirm"
                message="Are you want to group the following duplicate PCNs into a single group?"
                onConfirm={handleConfirmGrPcDuplicate}
            />

            <PopUpWarning
                {...popUpConfirmCancelPcHasPermit}
                title="Confirm"
                message="Are you sure you want to cancel this PC because the vehicle is on the Exemption list?"
                onConfirm={handleConfirmCancelPcHasPermit}
            />

            {selectedPhotoItemEvidence.CameraPhoto?.BlobName && (
                <Dialog
                    open={openPreview}
                    onClose={() => {
                        setOpenPreview(false);
                        setSelectedPhotoItemEvidence({} as CameraPhotoVehicles);
                    }}
                    PaperProps={{
                        sx: {
                            minWidth: 1280,
                            minHeight: 720,
                        },
                    }}
                >
                    <TransformWrapperComponent
                        handleTransform={handleTransform}
                        loading={loadingPhoto}
                        displayWidth={1280}
                        displayHeight={720}
                        scale={scalePhotos}
                        scaleZoomChangeCursor={scaleZoomChangeCursor}
                        image={imagePreviewEvidence}
                        stageRef={stageRef}
                        prevGeoZones={prevGeoZones}
                        cropArea={initialCropArea}
                    />
                </Dialog>
            )}
        </Stack>
    );
}

export const OrangeStack = styled(Stack)({
    background: color.gold200,
    borderRadius: `4px`,
    borderLeft: `4px solid ${color.gold600}`,
    padding: `12px 16px`,
});

const getOverTimeString = (outDate: Date, inDate: Date) => {
    const range = moment(outDate).diff(moment(inDate));
    const time = moment.duration(range);
    const hours = time.hours();
    const minutes = time.minutes();
    const seconds = time.seconds();

    return `${hours.toString().padStart(2, '0')}h ${minutes.toString().padStart(2, '0')}m ${seconds
        .toString()
        .padStart(2, '0')}s`;
};

export const MyAccordion = styled(Accordion)({
    '&.MuiPaper-root': {
        // border: `1px solid #DDDDDD`,
        boxShadow: `none`,
    },
});

interface ChangePlateButtonProps {
    updatingPlate: boolean;
    handleOpen: () => void;
}

const ChangePlateButton: React.FC<ChangePlateButtonProps> = ({ updatingPlate, handleOpen }) => (
    <LoadingButton
        sx={{ minWidth: '150px', justifyContent: updatingPlate ? 'space-between' : 'center' }}
        color="secondary"
        onClick={handleOpen}
        loading={updatingPlate}
        loadingPosition="start"
        startIcon={updatingPlate ? <></> : undefined}
        variant="orangeContained"
    >
        <span>Change plate</span>
    </LoadingButton>
);

interface AuditApproveButtonsProps {
    handleAuditAndApprove: (props: IAuditAndApprovePotentialContravention) => void;
    handleAuditAndSkip: (props: IAuditAndSkipPotentialContravention) => void;
    grId: number;
    pcId: number;
    selectedPc: PCInfo;
    idAudits: number[];
    isNoPCRestriction?: boolean;
    isEVWarning?: boolean;
    isExemptionPlate?: boolean;
}

const AuditApproveButtons: React.FC<AuditApproveButtonsProps> = ({
    handleAuditAndApprove,
    handleAuditAndSkip,
    grId,
    pcId,
    selectedPc,
    idAudits,
    isNoPCRestriction,
    isEVWarning,
    isExemptionPlate,
}) => {
    const disableReAuditAndApprove = (pcnDuplicate: PCNDuplicate[]): boolean => {
        const hasApprovedDuplicate = pcnDuplicate.some((pcn) => pcn.status === ContraventionStatus.Approved);
        const hasPendingStep2 = pcnDuplicate.some((pcn) => pcn.step === 2 || pcn.source === 'Stella');
        const allDuplicatesCancelled = pcnDuplicate.some((pcn) => pcn.status !== ContraventionStatus.Cancelled);

        return hasApprovedDuplicate || hasPendingStep2 || allDuplicatesCancelled;
    };
    const isCheckDuplicate = disableReAuditAndApprove(selectedPc.PCNDuplicate || []);

    return (
        <Stack position={'fixed'} right={30} direction={'row'} gap={2}>
            <Button
                variant="contained"
                sx={{ minWidth: '150px' }}
                disabled={
                    selectedPc?.PermitData?.hasPermit ||
                    selectedPc?.PermitData?.permitInfo?.isGlobalPermit ||
                    isCheckDuplicate ||
                    isNoPCRestriction ||
                    isEVWarning ||
                    isExemptionPlate
                }
                onClick={() =>
                    handleAuditAndApprove({
                        GroupPcId: grId,
                        PotentialContraventionId: pcId,
                    })
                }
            >
                Audit & Approve
            </Button>

            <Button
                variant="cancel"
                sx={{ minWidth: '150px' }}
                onClick={() =>
                    handleAuditAndSkip({
                        GroupPcId: grId,
                    })
                }
            >
                Audit & Skip
            </Button>
        </Stack>
    );
};
